import ProductStorageHandler from "../../persistence/ProductStorageHandle";
import type { BaseDeviceProps, GenericProductType } from "../../models/BaseDeviceProps";
export interface CatalogProductSelection {
  genericParams?: BaseDeviceProps;
  genericProductType?: GenericProductType;
  manufacturer: string;
  orderNumber: string;
  imageUrl?: string;
  catalogId?: string;
  variantArticleNumber?: string;
  descriptions?: Record<string, string>;
  catalogItem?: any;
}

/** Converts a catalog result for selection; the chosen device is persisted as a DeviceTemplate. */
export function createCatalogProduct(catalogItem: any): CatalogProductSelection {
  let descriptions: Record<string, string> = {};
  try {
    descriptions = catalogItem.ProductNames && typeof catalogItem.ProductNames === "object"
      ? { ...catalogItem.ProductNames }
      : JSON.parse(decodeURIComponent(catalogItem.ProductNames || "{}"));
  } catch {
    descriptions = {};
  }
  return {
    manufacturer: catalogItem.ManufacturerName || "",
    orderNumber: catalogItem.OrderNumber || "",
    catalogId: catalogItem.CatalogId || "",
    variantArticleNumber: catalogItem.VariantArticleNumber || "",
    descriptions,
    imageUrl: ProductStorageHandler.buildFrontImageUrl(
      catalogItem.OrderNumber || "",
      catalogItem.CatalogId || "",
      catalogItem.VariantArticleNumber,
    ),
    catalogItem,
  };
}
